<template>
  <div class="sezione "  style="padding:0 20px;">

<div >
<div class="title_h1 yo-color-primary" style="margin-top:30px;">XML FILES FOR VON</div>
<br />
In questa sezione potete gestire i files XML del VON
<br />
</div>
<div  v-if="$teras._xmlfiles.length>0">

   <div v-for="(itm,index) in $teras._xmlfiles" :key="index">
      <a :href="'https://api.innsin.it/xml4von/xmls/'+itm.filename" target="_blank" style="display:block;margin:8px 0;">{{itm.filename}}</a>
   </div> 
</div>

  
    <div class="row" style="margin-top:20px;border-top:1px solid #379EC2;padding-top:20px;">           
      <div class="col s12 m4 offset-m8" >
        <el-button style="width:100%;"  @click="genera()">Genera nuovo file XML</el-button>
      </div>
    </div>

<br /><br />&#160;

  </div>
</template>

<script>

export default {
  methods:{
    genera(){
      this.$axios.get('https://api.innsin.it/xml4von/createXml4VonJson.php','').then((response) =>  {
         if(response.data.esito){
            console.log("HA FUNZIONATO")
            this.$axios.query('fetchAll',`SELECT * FROM xmlfiles WHERE 1 ORDER BY filename`,{},this.$teras,'_xmlfiles')
            this.$message({dangerouslyUseHTMLString: true,type: 'success',message: 'Operazione riuscita'})

         }else{
            console.log("TROVATO UN ERRORE: "+ response.data.data.error)
            this.$message({dangerouslyUseHTMLString: true,type: 'error',message: response.data.data.error})
            this.$axios.query('fetchAll',`SELECT * FROM xmlfiles WHERE 1 ORDER BY filename`,{},this.$teras,'_xmlfiles')
         }
      }).catch((error) => {
        console.log("ERRORE NEL RECUPERO DELLA PAGINA")
        console.log(error.message)
      })
    }
  }

}
</script>

